import configData from './config.json';

/** Map Vite `--mode` to a key in `config.json` (local | prod; test for Playwright). */
function resolveAppEnv(viteMode) {
  if (viteMode === 'production') return 'prod';
  if (viteMode === 'test') return 'test';
  return 'local';
}

const modeKey = resolveAppEnv(import.meta.env.MODE);
const envConfig = configData[modeKey] || configData.local;

export const baseUrl = envConfig.API_BASE_URL;
export const appBaseUrl = envConfig.APP_BASE_URL;
export const projectMode = envConfig.PROJECT_MODE;

export const xsAuthClientId = import.meta.env.VITE_XS_AUTH_CLIENT_ID || envConfig.XS_AUTH_CLIENT_ID;
export const xsAuthUrl = import.meta.env.VITE_XS_AUTH_URL || envConfig.XS_AUTH_URL;
export const xsAuthBootstrapUrl =
  import.meta.env.VITE_XS_AUTH_BOOTSTRAP_URL || envConfig.XS_AUTH_BOOTSTRAP_URL || xsAuthUrl;
export const xsAccountUrl = import.meta.env.VITE_XS_ACCOUNT_URL || envConfig.XS_ACCOUNT_URL;
